import { ProductGroupFredhopperTypes } from '../../../enums/ActionEnums';
export const ProductGroupFredhopperActions = {
    init: () => ({
        type: ProductGroupFredhopperTypes.INIT,
    }),
    getDeliveryPromise: (payload) => ({
        type: ProductGroupFredhopperTypes.GET_DELIVERY_PROMISE,
        payload,
    }),
    setDeliveryPromise: (payload) => ({
        type: ProductGroupFredhopperTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
    setProductGroupFredhopperData: (payload) => ({
        type: ProductGroupFredhopperTypes.SET_FREDHOPPER_DATA,
        payload,
    }),
};
